import bgImg from "@/directives/bgImg";
import parallaxBackground from "@/directives/parallax-background";
import parallax from "@/directives/parallax/index";
import skip from "@/directives/skip/index";
import slideUpIn from "@/directives/slideUpIn/index";
import Vue from "vue";

Vue.use(parallax);
Vue.use(bgImg);
Vue.use(slideUpIn);
Vue.use(skip);
Vue.use(parallaxBackground);
